import React from 'react'
import { InvestorSummary } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { DescriptionList } from '../../atoms/DescriptionList'
import { DoubleColumnContent } from './DoubleColumnContent'
import { Card } from 'plume-ui'
import { CheckIcon } from '../../atoms/CheckIcon'

type Props = {
  summary: InvestorSummary
}

export const InvestmentInfo: React.FC<Props> = (props) => {
  return (
    <>
      <CardTitle>投資情報</CardTitle>
      <Card>
        <DoubleColumnContent>
          <DescriptionList
            list={{
              株主構成: { text: props.summary.shareholders },
              キャピタリスト数: {
                text: (
                  <>
                    {props.summary.numOfCapitalists &&
                      `${props.summary.numOfCapitalists}人`}
                  </>
                ),
              },
              JVCA会員: {
                text: <>{props.summary.jvcaMember && <CheckIcon />}</>,
              },
            }}
          />
          <DescriptionList
            list={{
              国内拠点: { text: props.summary.domesticBase },
              海外拠点: { text: props.summary.overseasBase },
            }}
          />
        </DoubleColumnContent>
      </Card>
    </>
  )
}
